import { reactive } from 'vue';

export const criarGabineteTpPessoa = () => {
    return reactive({
        id: 0,
        idmunicipio: 0,
        cdtppessoa: 0,
        nmtppessoa: '',
        ativo: 'S',
        idlogin: 0,
        idusuario: 0
    });
};